








































































































































import Vue from 'vue'
import {
  PostService,
  CategoryService,
  ProductService,
  QuestionService,
  QuizService,
  AssessmentStatusService,
  UserPurchaseService,
  UserPostCompletionService,
  getUserId,
  UserProductTrackingService,
} from '@/services'
import CategoryPostBreadcrumbs from '@/components/common/CategoryPostBreadcrumbs.vue'
import Question from '@/components/assessments/Question.vue'
import { Button } from 'view-design'
import { createCategoryPostTree, computeNextPost, sliceLongText } from '../helper'
import { adminMode } from '@/helper/permission.helper'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'
import UISpinner from '@/components/common/UISpinner.vue'

export default Vue.extend({
  data() {
    return {
      post: {},
      category: {},
      product: {},
      parentCategory: {},
      nextPost: {},
      quiz: {},
      assessmentStatus: null,
      questions: [],
      quizResponse: [],
      categoryTree: [],
      submittingAnswer: false,
      showingResults: false,
      postMarkedAsCompleted: false,
      disablePostCompletionButton: false,
      productStarted: true,
      questionCount: 0,
      correctCount: 0,
      incorrectCount: 0,
      fetching: true
    }
  },
  components: {
    CategoryPostBreadcrumbs,
    Question,
    Button,
    BaseIcon,
    UISpinner
  },
  computed: {
    resultMessageColor(): string {
      return this.assessmentStatus && this.assessmentStatus.status === 'passed' ? 'green' : 'red'
    },
    pageTopMessage() {
      return `<span class='text-sm'>${ this.correctCount } / ${ this.questionCount } Questions answered correctly and scored <span class='text-${this.resultMessageColor}-500 font-semibold'>${ this.assessmentStatus.score }%</span></span>` +
      `<span class='text-xs'>` + ((
        this.assessmentStatus.status === 'passed' ? this.quiz.passMessage : this.quiz.failMessage
      ) || '') + `</span>` 
    },
    postId() {
      return this.$route.params.post_id
    },
    productId() {
      return this.post.productId
    },
    categoryId() {
      return this.$route.params.category_id
    },
    themeSettings(): object {
      return this.product.customizations?.lessonSettings?.themeSettings
    },
    goBackIcon(): string {
      if (this.sections?.courseNavigation?.breadCrumb?.color) {
        return this.sections?.courseNavigation?.breadCrumb?.color
      } else if (this.themeSettings?.primaryStyle?.color) {
        return this.themeSettings?.primaryStyle.color
      }
      return '#111827'
    },
    parentCategoryTitle(): string {
      return sliceLongText(this.parentCategorytitle?.title)
    },

    categoryTitle(): string {
      return sliceLongText(this.category.title)
    },

    postTitle(): string {
      return sliceLongText(this.post.title)
    },

    lessonSettings(): object {
      return this.product.customizations?.lessonSettings
    },
    lessonBody(): object {
      return this.lessonSettings?.sections?.lessonBody
    },
    lessonButton(): object {
      return this.lessonBody?.button || null
    },
    postCompletionButtonText(): string {
      if (this.disablePostCompletionButton) {
        return this.postMarkedAsCompleted
          ? 'Marking as Incomplete'
          : 'Completing..'
      } else {
        return this.postMarkedAsCompleted
          ? 'Completed'
          : this.lessonButton?.content
          ? this.lessonButton.content
          : 'Mark As Complete'
      }
    },
    isAdmin() {
      return adminMode()
    }
  },
  async mounted() {
    this.fetching = true
    await Promise.all([
      this.fetchPost(),
      this.fetchCategory(),
    ])
    await this.checkIfPostCompleted(this.postId)
    await this.createCategoryTree()
    await this.fetchProduct()
    await this.fetchNextPost()
    if (this.$route.query.review === true) {
      this.showingResults = true
      this.getLastSubmission()
    }
    this.fetching = false
  },
  methods: {
    async getLastSubmission() {
      try {
        const fetchedSubmission = await AssessmentStatusService.getLastSubmissionByPostId(this.postId)
        this.assessmentStatus = fetchedSubmission.data.lastSubmission
        if (this.assessmentStatus) {
            this.questionCount = this.assessmentStatus.submission.length;
            this.correctCount = this.assessmentStatus.submission.filter(e => e.correctAnswerGiven).length;
            this.incorrectCount = this.assessmentStatus.submission.filter(e => !e.correctAnswerGiven).length;
        }
        this.processAssessmentResponse(fetchedSubmission.data.lastSubmission.submission)
      } catch (error) {
        console.error(`Error getting last submission`, error);
      }
    },
    async checkIfPostCompleted(postId: string) {
      try {
        this.fetchingPostCompletionStatus = true

        const data = await UserPostCompletionService.checkIfPostCompleted(
          postId
        )

        if (data && data.length) {
          this.post.postCompletedRef = data[0].id
          this.postMarkedAsCompleted = true
        } else {
          this.postMarkedAsCompleted = false
        }
      } catch (error) {
        console.error('Error while checking if post is completed --> ', error)
      } finally {
        this.fetchingPostCompletionStatus = false
      }
    },
    async markPostAsCompleted() {
      const data = await UserPostCompletionService.markPostAsCompleted({
        postId: this.postId,
        productId: this.productId
      })

      this.post.postCompletedRef = data.id
    },
    async markPostAsIncomplete() {
      if (this.post.postCompletedRef) {
        await UserPostCompletionService.markPostAsIncomplete(
          this.post.postCompletedRef
        )
      }

      this.post.postCompletedRef = null
    },
    async togglePostCompletion() {
      try {
        this.disablePostCompletionButton = true

        if (this.postMarkedAsCompleted) {
          await this.markPostAsIncomplete()
          this.postMarkedAsCompleted = false
        } else {
          if (!this.productStarted) {
            UserProductTrackingService.trackProductStart(this.productId)
          }
          await this.markPostAsCompleted()
          this.postMarkedAsCompleted = true
          await this.fetchNextPost()
        }
      } catch (error) {
        console.error('error while changing post completion status --> ', error)
      } finally {
        this.disablePostCompletionButton = false
      }
    },
    async createCategoryTree() {
      const categories = await UserPurchaseService.getCategories({
        product_id: this.productId
      })

      this.categoryTree = createCategoryPostTree(null, categories)
    },
    async fetchNextPost() {
      // fetch user post completion data
      const userId = getUserId()

      const completedResp = await UserPostCompletionService.findAll({
        product_id: this.productId,
        user_id: userId
      })

      const postIdsCompleted = completedResp.reduce(
        (agg: Set<string>, completed: any) => {
          const { postId } = completed
          agg.add(postId)
          return agg
        },
        new Set()
      )

      const nextPost = computeNextPost(this.categoryTree, postIdsCompleted)
      this.nextPost = nextPost ? nextPost.node : null
    },
    goToNextPost() {
      this.$router.push({
        name: 'post-overview',
        params: {
          id: this.productId,
          category_id: this.nextPost.categoryId,
          post_id: this.nextPost.id
        }
      })
    },
    async fetchPost() {
      try {
        this.post = await PostService.findById(this.postId)
        await this.fetchQuiz()
      } catch (error) {
        console.error(`Error fetching post: ${error}`)
      }
    },
    async fetchCategory() {
      try {
        this.category = await CategoryService.findById(this.categoryId)
        if (this.category.parentCategory) {
          this.parentCategory = await CategoryService.findById(this.category.parentCategory)
        }
      } catch (error) {
        console.error(`Error fetching Category: ${error}`)
      }
    },
    async fetchProduct() {
      try {
        this.product = await ProductService.findById(this.productId)
      } catch (error) {
        console.error(`Error fetching Product: ${error}`)
      }
    },
    async fetchQuiz() {
      try {
        const fetchedQuiz = await QuizService.findById(this.post.id)
        this.quiz = fetchedQuiz
        await this.fetchQuestions(this.quiz.id)
      } catch (error) {
        console.error(`Error: fetching quiz ${JSON.stringify(error)}`)
      }
    },
    async fetchQuestions(quizId: string) {
      try {
        const fetchedQuestions = await QuestionService.findQuestionsByQuizId(quizId)
        this.questions = fetchedQuestions.data
      } catch (error) {
        console.error(`Error: fetchingQuestions ${JSON.stringify(error)}`)
      }
    },
    async updateQuizResponse(payload: {
      selected: number,
      questionSequenceNumber: number,
      questionId: string
    }) {
      const responseIndex = this.quizResponse.findIndex(elem => elem.questionSequenceNumber === payload.questionSequenceNumber)
      const questionElemInQuestions = this.questions.find(elem => elem.id === payload.questionId)

      if (responseIndex === -1) {
        this.quizResponse.push({
          questionSequenceNumber: payload.questionSequenceNumber,
          selectedRespoonseSequenceNumbers: [ payload.selected ],
          questionId: payload.questionId
        })
      } else {
        if (questionElemInQuestions.questionType === 'single') {
          this.quizResponse[responseIndex].selectedRespoonseSequenceNumbers = []
        }
        this.quizResponse[responseIndex]
          .selectedRespoonseSequenceNumbers
          .push(payload.selected)
      }
    },

    async removeQuizResponse(payload: {
      toUnselect: number,
      questionSequenceNumber: number,
    }) {
      const responseIndex = this.quizResponse.findIndex(elem => elem.questionSequenceNumber === payload.questionSequenceNumber)
      if (responseIndex > -1) {
        const filteredSequenceNumbers = this
          .quizResponse[responseIndex]
          .selectedRespoonseSequenceNumbers
          .filter(elem => elem !== payload.toUnselect)
        this.quizResponse[responseIndex].selectedRespoonseSequenceNumbers = filteredSequenceNumbers
      }
    },

    async submitQuiz() {
      try {
        this.submittingAnswer = true
        const submission : {
          questionId: string,
          statement: string,
          explanation: string,
          optionResponses: {
            sequence: number,
            isChosen: boolean,
            isCorrect: boolean,
            statement: string
          } [] 
        }[] = []
        this.questions.forEach(elem => {
          const foundQuizResponse = this.quizResponse.find(quizResponseElem => {
            if(quizResponseElem.questionId === elem.id) {
              return true
            }
          })
          const optionsFromQuizResponse = foundQuizResponse ? foundQuizResponse.selectedRespoonseSequenceNumbers: []

          const submissionOptions = elem.options.map(option => {
            return {
              sequence: option.sequence,
              isChosen: optionsFromQuizResponse.includes(option.sequence),
              isCorrect: option.isCorrect,
              statement: option.statement
            }
          })
          submission.push({
            questionId: elem.id,
            statement: elem.title,
            optionResponses: submissionOptions,
            explanation: elem.explanation
          })
        })

        const assessmentSubmissionResponse = await AssessmentStatusService.create({
          postId: this.postId,
          quizId: this.quiz.id,
          productId: this.productId,
          submission,
          submissionType: 'quiz'
        })
        await this.getLastSubmission()
        this.submittingAnswer = false
        this.processAssessmentResponse(assessmentSubmissionResponse.data.submission)
      } catch (error) {
        console.error(`Error: Submitting Quiz: ${JSON.stringify(error.message)}`)
      }
      window.scrollTo(0, 0)
    },

    async resetForRetake() {
      this.fetching = true
      this.quizResponse = []
      this.questions = []
      await this.fetchQuestions(this.quiz.id)
      this.showingResults = false
      this.fetching = false
      window.scrollTo(0, 0)
    },

    async processAssessmentResponse(payload) {
      this.showingResults = true
      this.questions.forEach((elem, index) => {
        elem.correctAnswerGiven = payload[index].correctAnswerGiven
        elem.explanation = payload[index].explanation
        elem.options = payload[index].optionResponses
      })
    }
  }
})
